import useQueryParams from '@helpers/hooks/useQueryParams'

const QUERY_PARAM = 'filters'

export function useFiltersToggle() {
  const { setQueryParams, queryParams, removeQueryParams } = useQueryParams<{
    [QUERY_PARAM]: string
  }>({
    [QUERY_PARAM]: ''
  })

  const isFiltersOpen = queryParams[QUERY_PARAM] === 'true'

  const handleOpenFilters = () => {
    setQueryParams({ [QUERY_PARAM]: 'true' })
  }

  const handleCloseFilters = () => {
    if (isFiltersOpen) {
      removeQueryParams([QUERY_PARAM])
    }
  }

  return {
    isFiltersOpen,
    openFilters: handleOpenFilters,
    closeFilters: handleCloseFilters
  }
}
